import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Maximize2Icon } from 'lucide-react';
import { Section } from '../Section';
import { InView } from '../InView';
import { SectionHeadline } from '../SectionHeadline';
import { ImageWindow } from '../ImageWindow';
import { referenceClients, referencesImage } from '../../../data/deck';

/** Source is ~2560 × 1412; crop away the screenshot's own title row. */
const SOURCE = {
  width: 2560,
  height: 1412
};
const CROP_TOP = 200;
export function ReferencesSection() {
  const [open, setOpen] = useState(false);
  return <Section id="references" data-id="element-546" data-mp="35vmvtvz1mbe3">
      <AnimatePresence data-id="element-547" data-mp="35wxxnq8xh92k">
        {open && <ImageWindow key="references" src={referencesImage} alt="A collage of Snaks used across the customer journey for life science companies" title="Snaks throughout the customer journey" onClose={() => setOpen(false)} data-id="element-548" data-mp="35tjvai09kzv4" />}
      </AnimatePresence>

      <div className="grid items-end gap-8 lg:grid-cols-[minmax(0,1fr)_420px] lg:gap-16" data-id="element-549" data-mp="3s43jr67oerra">
        <InView data-id="element-550" data-mp="x0rsck0khg0">
          <span className="mb-5 inline-flex rounded-full bg-[var(--brand)] px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-white" data-id="element-551" data-mp="whmbvbjvliv">
            Meet Snakker
          </span>
          <SectionHeadline lead="Trusted across" follow="the customer journey." data-id="element-552" data-mp="9yh3cnmkeplt" />
        </InView>
        <InView delay={0.1} data-id="element-553" data-mp="39dm525johwox">
          <p className="text-[14.5px] leading-[1.7] text-[var(--muted)]" data-id="element-554" data-mp="39edo6gw3a1yb">
            <span className="font-semibold text-[var(--fg)]" data-id="element-555" data-mp="3ddwbtkfaor4u">A boutique life science AI agency</span> creating engaging,
            interactive experiences for HCPs — from congress hooks and awareness teasers to clinical cases, peer polls and
            follow-ups. Each one measured and reported.
          </p>
          <ul className="mt-4 flex flex-wrap gap-1.5" data-id="element-556" data-mp="2po21b9ig7enr">
            {referenceClients.map(client => <li key={client} className="rounded-full border border-[var(--fg)]/15 bg-white px-3 py-1 text-[12px] font-semibold text-[var(--fg)]" data-id="element-557" data-mp="2umvdmym00zmc">
                {client}
              </li>)}
          </ul>
        </InView>
      </div>

      <InView delay={0.16} y={26} className="mt-12" data-id="element-558" data-mp="akyjen6oc969">
        <button type="button" onClick={() => setOpen(true)} aria-label="Enlarge the reference collage" className="group relative block w-full overflow-hidden rounded-[28px] bg-white p-4 text-left shadow-[0_50px_90px_-60px_rgba(14,27,51,0.6)] ring-1 ring-[var(--fg)]/[0.08] transition-shadow hover:ring-2 hover:ring-[var(--brand)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] sm:p-6" data-id="element-559" data-mp="6kejjbupurgf">
          <div className="relative overflow-hidden" style={{
          aspectRatio: `${SOURCE.width} / ${SOURCE.height - CROP_TOP}`
        }} data-id="element-560" data-mp="3j09upfwd7w39">
            <img src={referencesImage} alt="A collage of Snaks for Roche, Siemens Healthineers, AbbVie, Novartis, Novo Nordisk, GSK, CSL Vifor, Solventum and more — many with campaign reports" className="block w-full" style={{
            marginTop: `-${CROP_TOP / SOURCE.width * 100}%`
          }} data-id="element-561" data-mp="ycdmwja6swj3" />
          </div>
          <span className="absolute right-6 top-6 inline-flex items-center gap-1.5 rounded-full bg-[var(--fg)] px-3 py-1.5 text-[11px] font-bold text-white opacity-90 shadow-md transition-opacity group-hover:opacity-100" data-id="element-562" data-mp="wwrr93rdxr6f">
            <Maximize2Icon className="h-3 w-3" aria-hidden="true" data-id="element-563" data-mp="1uip2qh7ckw8v" />
            Enlarge
          </span>
        </button>
      </InView>

      <InView delay={0.3} data-id="element-564" data-mp="1fshusveyuvmf">
        <p className="mt-12 border-t border-[var(--fg)]/10 pt-8 text-[24px] font-extrabold leading-[1.15] tracking-[-0.03em] text-[var(--fg)] sm:text-[30px]" data-id="element-565" data-mp="1fr6pgr5vhft7">
          Attract, convince, convert and follow up —{' '}
          <span className="text-[var(--brand)]" data-id="element-566" data-mp="2d8op2wbszx8l">with one format, at every step.</span>
        </p>
      </InView>
    </Section>;
}